/** Texto mostrado tras instalar o activar licencia (PDF o clave). No sustituye asesoría legal. */
export const LICENSE_INSTALL_NOTICE_TITLE = "Licencia registrada — uso de la información";

export const LICENSE_INSTALL_NOTICE_PARAS = [
  "La información fiscal y operativa que cargue en este sistema es bajo su responsabilidad y la de su organización.",
  "El software no sustituye el asesoramiento profesional ni garantiza resultados ante el SAT u otros terceros.",
  "Los datos que opera en el programa permanecen en esta instalación o en el entorno donde ejecute la aplicación; no constituyen un respaldo remoto automático por parte del proveedor salvo funciones explícitas de exportación o copia que usted utilice.",
  "Conserve el PDF de solicitud y la documentación contractual que acuerde con su distribuidor como respaldo de autorización y condiciones de uso.",
];
